import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, Route, Switch, Redirect} from 'react-router-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'

// Containers
import Full from './containers/Full/'

// Views
import Login from './views/Pages/Login/';

// MobX Store
import { Provider } from "mobx-react";
import store from "./services/_store";
window.store = store;

// toast
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { UploadImageModal } from 'common-import/custom';
import ReactTooltip from 'react-tooltip'
window.toast = toast;

ReactDOM.render((
  <Provider {...store}>
    <Fragment>
      <ToastContainer autoClose={4000} />
      <HashRouter>
        <Switch>
          <Route exact path="/login" name="Login Page" component={Login}/>
          <Route path="/" name="Dashboard" component={Full}/>
          {/* <Redirect from="/" to="/login" /> */}
        </Switch>
      </HashRouter>
      <UploadImageModal />
      <ReactTooltip />
    </Fragment>
  </Provider>
), document.getElementById('root'));

// document.location = "/#/login";



// WEBPACK FOOTER //
// ./src/index.js